import { useCallback } from "react";

import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import useView from "../../component/view/utils/useView";

// clears filters for all fields except skipFields
const useClearFilters = (skipFields?: IField[]) => {
  const { fieldModel, updateFilterModel, updateViewAs } = useView();

  return useCallback(() => {
    const skipFieldsFilterNames = new Set((skipFields ?? []).map(({ filterName }) => filterName));
    updateFilterModel(
      fieldModel.fields.reduce(
        (result, field) =>
          skipFieldsFilterNames.has(field.filterName)
            ? result
            : Object.assign(result, { [field.filterName]: undefined }),
        {}
      )
    );
    updateViewAs(undefined);
  }, [fieldModel, skipFields, updateFilterModel, updateViewAs]);
};

export default useClearFilters;
